<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-microwave`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.762 8h40.476C45.211 8 46 8.658 46 9.47v30.06c0 .812-.789 1.47-1.762 1.47H3.762C2.789 41 2 40.342 2 39.53V9.47C2 8.659 2.789 8 3.762 8zM42 12H6v25h36V12zm-13 4a1 1 0 011 1v15a1 1 0 01-1 1H11a1 1 0 01-1-1V17a1 1 0 011-1h18zm-15 4v9h12v-9H14zm19 2h6a1 1 0 011 1v2a1 1 0 01-1 1h-6a1 1 0 01-1-1v-2a1 1 0 011-1zm3-6a2 2 0 110 4 2 2 0 010-4zm-3 12h6a1 1 0 011 1v2a1 1 0 01-1 1h-6a1 1 0 01-1-1v-2a1 1 0 011-1z"/></svg>
</template>
<script>

export default {
  name: 'IconMicrowave',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
